import { GET, POST, PUT, DELETE } from './api';

export const ReadMyHistory = async (profileId: number | string, token: string) => {
  return await GET(
    `/histories?profile=${profileId}&populate[0]=stream_show.thumbnail&[limit]=9`,
    token,
  );
};

export const AddHistory = async (profileId: number | string, params: unknown, token: string) => {
  return await POST(`/histories?profile=${profileId}`, params, token);
};

export const RemoveHistory = async (profileId: number | string, token: string) => {
  return await DELETE(`/histories?profile=${profileId}`, token);
};
